import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EditPartnerComponent } from './edit-partner.component';

const routes: Routes = [{ path: ':id', component: EditPartnerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditPartnerRoutingModule {}
